const blankToNull = require('./../../../utils').blankToNull

export function validate(record) {
  const errors = []
  if (!record.nome) {
    errors.push({
      field: 'nome',
      message: 'O campo Nome é obrigatório',
    })
  }
  if (!record.unidade) {
    errors.push({
      field: 'unidade',
      message: 'O campo Unidade é obrigatório',
    })
  }

  if (!record.tipo) {
    errors.push({
      field: 'tipo',
      message: 'O campo Tipo é obrigatório',
    })
  }

  if (!record.consultaSql) {
    errors.push({
      field: 'consultaSql',
      message: 'O campo Consulta SQL é obrigatório',
    })
  }
  if (!record.requisicao) {
    errors.push({
      field: 'requisicao',
      message: 'O campo Requisiçãpo é obrigatório',
    })
  }
  if (!record.formato) {
    errors.push({
      field: 'formato',
      message: 'O campo Formato é obrigatório',
    })
  }

  blankToNull(record)
  const result = {
    ok: errors.length === 0,
    errors,
    record,
  }
  return new Promise((resolve, reject) => {
    const action = result.ok ? resolve : reject
    return action(result)
  })
}
